// extracted by mini-css-extract-plugin
module.exports = {"footer":"EmailFooter_footer__2XLft"};